import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ManageRolesForUsersContent from '../components/pages/waiting-area/manage-users/manageRolesModal';

function ManageRolesForUsersModal(props) {
  const showManageRolesForUsersModal = useSelector((state) => state.modalReducer.showManageRolesForUsersModal);
  const manageRolesSelectedUserId = useSelector((state) => state.waitingAreaReducer.manageUsersPage.selectedUserId);
  const rolesForSelectedUser = useSelector((state) => state.waitingAreaReducer.manageUsersPage.rolesForSelectedUser);
  const dispatch = useDispatch();

  return (
    <div>
      <ManageRolesForUsersContent
        waitingArea={props.waitingArea}
        availableRoles={props.availableRoles}
        usersIcanManage={props.usersIcanManage}
        manageRolesSelectedUserId={manageRolesSelectedUserId}
        showManageRolesForUsersModal={showManageRolesForUsersModal}
        rolesForSelectedUser={rolesForSelectedUser}
        dispatch={dispatch}
      />
    </div>
  );
}

export default ManageRolesForUsersModal;
